import { ErrorCode, type FileRejection } from 'react-dropzone';

interface DropzoneErrorMessages {
	maxSize: string;
	invalidType: string;
}

export const getDropzoneErrorMessage = (
	fileRejections: FileRejection[],
	messages: DropzoneErrorMessages,
): string | null => {
	const hasMaxSizeError = fileRejections.some(rejection =>
		rejection.errors.some(error => error.code === ErrorCode.FileTooLarge),
	);
	if (hasMaxSizeError) return messages.maxSize;

	const hasInvalidTypeError = fileRejections.some(rejection =>
		rejection.errors.some(error => error.code === ErrorCode.FileInvalidType),
	);
	if (hasInvalidTypeError) return messages.invalidType;

	// Custom validators (e.g. a per-media-type size limit) carry their own message
	const customError = fileRejections
		.flatMap(rejection => rejection.errors)
		.find(error => Boolean(error.message));

	return customError?.message ?? null;
};
